export default [

    {
        "text": "Sites",
        "icon": "ti-clipboard",
        "route": "sites",
        "permission": "Voir la page d'acceuil",
    },
    {
        "text": "Annuaires",
        "icon": "ti-clipboard",
        "route": "annuaires",
        "permission": "Voir la page d'acceuil",
    },
    {
        "text": "Travaux",
        "icon": "ti-hammer",
        "route": "",
        "submenu": [
            {
                "text": "Sous traitants",
                "route": "soustraitants",
                "icon": "ti-id-badge",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Chantiers type",
                "route": "typesbatiments",
                "icon": "ti-home",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Groupes corps etats",
                "route": "groupescorpsetats",
                "icon":  "ti-building",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Corps etats",
                "route": "corpsetats",
                "icon": "ti-list",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Taches",
                "route": "taches",
                "icon": "ti-list",
                "permission": "Voir la page des utilisateurs"
            }
        ]
    },
    {
        "text": "Fournitures",
        "icon": "ti-package",
        "route": "",
        "submenu": [
            {
                "text": "Listes des fournitures",
                "route": "fournitures",
                "icon": "ti-clipboard",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Listes des familles",
                "route": "familles",
                "icon": "ti-tag",
                "permission": "Voir la page des utilisateurs"
            }
        ]
    },
    {
        "text": "Entreprises ",
        "icon": "ti-lock",
        "route": "",
        "submenu": [
            {
                "text": "Directions",
                "route": "directions",
                "icon": "ti-user",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Services",
                "route": "services",
                "icon": "ti-user",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Fonctions",
                "route": "fonctions",
                "icon": "ti-user",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Pays d'achat",
                "route": "pays",
                "icon": "",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Coefficients d'imports",
                "route": "coefficients",
                "icon": "",
                "permission": "Voir la page des utilisateurs"
            },

        ]
    },
    {
        "text": "Administration utilisateurs ",
        "icon": "ti-lock",
        "route": "",
        "module": "Administration",
        "submenu": [
            {
                "text": "Les users",
                "route": "users",
                "icon": "ti-user",
                "permission": "Voir la page des utilisateurs"
            },
            {
                "text": "Les super admin",
                "route": "Users_SU",
                "icon": "ti-shield",
                "permission": "Voir la page des superAdmin",
                "isSu": true
            },
            {
                "text": "Roles / Profils",
                "route": "roles",
                "icon": "ti-layout",
                "params": {
                    "type": "brute"
                },
                "permission": "Voir la page des roles"
            },
            {
                "text": "Permissions",
                "route": "permissions",
                "icon": "ti-layout",
                "isSu": true,
                "params": {
                    "type": "brute"
                },
                "permission": "Voir la page des permissions"
            }
        ]
    }
]
